export enum WebBrowser {
  CHROME = "CHROME",
  SAFARI = "SAFARI"
}
